import { useQuery } from '@tanstack/react-query';
import { ChangeEvent, FormEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getFactoryList } from 'api/deviceApi';
import { DeviceSearchRequest } from 'api/DeviceRequest';
import { factoryKeys } from 'api/quires/queryKeys';

import Factory from '../../model/Factory';

type DeviceSearchBoxProps = {
  searchRequest: DeviceSearchRequest;
  isLoading: boolean;
  onSubmit: (factoryInfo: Factory | null, event?: FormEvent) => void;
  isRefetch?: boolean;
};
export default function DeviceSearchBox({
  searchRequest,
  isLoading,
  onSubmit,
  isRefetch = false,
}: DeviceSearchBoxProps) {
  const { t } = useTranslation();
  const {
    data,
    isLoading: isFactoryLoading,
    refetch,
  } = useQuery(
    factoryKeys.detail(searchRequest.localId ?? ''),
    () => getFactoryList(searchRequest.localId ?? ''),
    { cacheTime: 600000, staleTime: 600000 },
  );

  const getFactoryInfo = (id: string) =>
    data?.list?.find((item) => item.id === +id) ?? null;

  useEffect(() => {
    if (!data && isFactoryLoading) {
      return;
    }

    const initFactoryId = !searchRequest.factoryId
      ? data?.list[0]?.id.toString() ?? '0'
      : searchRequest.factoryId;
    onSubmit(getFactoryInfo(initFactoryId));
  }, [data]);

  useEffect(() => {
    if (isRefetch) {
      refetch();
    }
  }, [isRefetch, refetch]);

  const onChangeFactory = (event: ChangeEvent<HTMLSelectElement>): void => {
    const changedFactoryId = event.target.value;

    onSubmit(getFactoryInfo(changedFactoryId), event);
  };

  return (
    <form
      onSubmit={(event) =>
        onSubmit(getFactoryInfo(searchRequest.factoryId), event)
      }
    >
      <div className={'filter-wrap'}>
        <div className={'filter'}>
          <dl>
            <dt>{t('home.plant')}</dt>
            <dd className={'mg30r'}>
              <select
                onChange={onChangeFactory}
                value={searchRequest.factoryId}
              >
                {data?.list?.map((factory) => (
                  <option key={factory.id} value={factory.id}>
                    {factory.name}
                  </option>
                ))}
              </select>
            </dd>
          </dl>
        </div>
        <button
          type={'submit'}
          className={'black_white_btn btn_search'}
          disabled={isLoading}
        >
          {t('button.search')}
        </button>
      </div>
    </form>
  );
}
